import styled, { css } from "styled-components"

export const SignatureWrapper = styled.div`
  ${(props) =>
    props?.simpleForm &&
    css`
      border: 1px solid #e6e6e6;
      border-radius: 8px;
    `}
`
